import { formatDate, toIsoDate } from "@/helpers/author";

export default {
  name: "author-article-card",
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    link() {
      return this.$localize({ name: "news-single", params: { slug: this.article.slug } });
    },
    date() {
      return formatDate(this.article.publishedAt);
    },
    isoDate() {
      return toIsoDate(this.article.publishedAt);
    },
  },
};
